/**
 * Internal dependencies
 */
import {
    PAYMENT_METHODS_RECEIVE,
    PAYMENT_METHODS_REQUEST,
    PAYMENT_METHODS_REQUEST_SUCCESS,
    PAYMENT_METHODS_REQUEST_FAILURE,
    PAYMENT_METHODS_REMOVE_SUCCESS,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { setPrimaryPaymentSourceId } from 'state/current-user/actions';
import { get } from 'lodash';

/**
 * [description]
 *
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestPaymentMethods = () => (dispatch) => {
    dispatch({
        type: PAYMENT_METHODS_REQUEST,
    });
    return cscom
        .paymentMethod()
        .list()
        .then((items) => {
            dispatch({
                type: PAYMENT_METHODS_REQUEST_SUCCESS,
            });
            dispatch({
                type: PAYMENT_METHODS_RECEIVE,
                payload: { items },
            });
            return items;
        })
        .catch((error) => {
            dispatch({
                type: PAYMENT_METHODS_REQUEST_FAILURE,
                error,
            });
        });
};

export const createPaymentMethodUsingToken = (token) => (dispatch) => {
    return cscom
        .paymentMethod()
        .createUsingToken(token)
        .then((result) => {
            dispatch({
                type: PAYMENT_METHODS_RECEIVE,
                payload: { items: [result] },
            });
            dispatch(setPrimaryPaymentSourceId(result.id));
            return result;
        });
};

export const removePaymentMethod = (paymentMethodId) => (dispatch) => {
    return cscom
        .paymentMethod()
        .removePaymentMethod(paymentMethodId)
        .then((result) => {
            dispatch(setPrimaryPaymentSourceId(get(result, 'customer.primary_payment_source_id', null)));
            dispatch({ type: PAYMENT_METHODS_REMOVE_SUCCESS, payload: { paymentMethodId } });
        });
};
